'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  ', '\n\n  background: ', ';\n  margin-bottom: ', ';\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: ', ';\n\n  ', '\n\n  .image-gallery-left-nav,\n  .image-gallery-right-nav {\n    border: 1px solid ', ';\n    font-size: ', ';\n    margin-top: 30px;\n    padding: 10px;\n    top: 100%;\n    transform: none;\n\n    &::before {\n      color: ', ';\n      font-weight: 700;\n      text-shadow: none;\n    }\n  }\n\n  .image-gallery-left-nav {\n    margin-left: 10px;\n  }\n\n  .image-gallery-right-nav {\n    margin-right: 10px;\n  }\n\n  .image-gallery-thumbnails-wrapper {\n    padding: 0 50px;\n  }\n\n  .image-gallery-thumbnail {\n    border: none;\n    margin: 5px 5px 5px 0;\n    width: auto;\n\n    img {\n      height: 90px;\n      width: auto;\n    }\n\n    + .image-gallery-thumbnail {\n      margin-left: 5px;\n    }\n\n    &:not(.active) {\n      opacity: 0.5;\n    }\n\n    &.active {\n      border: none;\n\n      img {\n        outline: 3px solid ', ';\n        outline-offset: -3px;\n      }\n    }\n  }\n'], ['\n  ', '\n\n  background: ', ';\n  margin-bottom: ', ';\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: ', ';\n\n  ', '\n\n  .image-gallery-left-nav,\n  .image-gallery-right-nav {\n    border: 1px solid ', ';\n    font-size: ', ';\n    margin-top: 30px;\n    padding: 10px;\n    top: 100%;\n    transform: none;\n\n    &::before {\n      color: ', ';\n      font-weight: 700;\n      text-shadow: none;\n    }\n  }\n\n  .image-gallery-left-nav {\n    margin-left: 10px;\n  }\n\n  .image-gallery-right-nav {\n    margin-right: 10px;\n  }\n\n  .image-gallery-thumbnails-wrapper {\n    padding: 0 50px;\n  }\n\n  .image-gallery-thumbnail {\n    border: none;\n    margin: 5px 5px 5px 0;\n    width: auto;\n\n    img {\n      height: 90px;\n      width: auto;\n    }\n\n    + .image-gallery-thumbnail {\n      margin-left: 5px;\n    }\n\n    &:not(.active) {\n      opacity: 0.5;\n    }\n\n    &.active {\n      border: none;\n\n      img {\n        outline: 3px solid ', ';\n        outline-offset: -3px;\n      }\n    }\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _transparentize = require('polished/lib/color/transparentize');

var _transparentize2 = _interopRequireDefault(_transparentize);

var _rem = require('polished/lib/helpers/rem');

var _rem2 = _interopRequireDefault(_rem);

var _reactImageGallery = require('react-image-gallery');

var _reactImageGallery2 = _interopRequireDefault(_reactImageGallery);

var _imageGallery = require('react-image-gallery/styles/css/image-gallery.css');

var _imageGallery2 = _interopRequireDefault(_imageGallery);

var _config = require('../../config.js');

var _mixins = require('../../mixins');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ImageGalleryContainer = _styledComponents2.default.section(_templateObject, _imageGallery2.default, _config.colors.white, function (props) {
  return props.hasBottomMargin ? '30px' : '0';
}, function (props) {
  return props.hasTopMargin ? '30px' : '0';
}, function (props) {
  return props.hasTopMargin || props.hasBottomMargin ? (0, _mixins.ClearFix)() : '';
}, (0, _transparentize2.default)(0.5, _config.colors.red), (0, _rem2.default)('25px', _config.typography.baseFontSize), _config.colors.red, _config.colors.red);

ImageGalleryContainer.displayName = 'ImageGalleryContainer';

var ImageGallery = function ImageGallery(_ref) {
  var hasBottomMargin = _ref.hasBottomMargin,
      hasTopMargin = _ref.hasTopMargin,
      images = _ref.images;
  return _react2.default.createElement(
    ImageGalleryContainer,
    {
      hasBottomMargin: hasBottomMargin,
      hasTopMargin: hasTopMargin
    },
    _react2.default.createElement(_reactImageGallery2.default, {
      items: images,
      showFullscreenButton: false,
      showPlayButton: false
    })
  );
};

ImageGallery.propTypes = {
  /** Whether or not a 30px bottom margin is applied. */
  hasBottomMargin: _propTypes2.default.bool,
  /** Whether or not a 30px top margin is applied. */
  hasTopMargin: _propTypes2.default.bool,
  /** An array of objects representing images and their thumbnails. */
  images: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    original: _propTypes2.default.string,
    thumbnail: _propTypes2.default.string,
    originalAlt: _propTypes2.default.string,
    thumbnailAlt: _propTypes2.default.string
  })).isRequired
};

ImageGallery.defaultProps = {
  hasBottomMargin: true,
  hasTopMargin: true
};

ImageGallery.displayName = 'ImageGallery';

exports.default = ImageGallery;
ImageGallery.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'ImageGallery',
  'props': {
    'hasBottomMargin': {
      'defaultValue': {
        'value': 'true',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether or not a 30px bottom margin is applied.'
    },
    'hasTopMargin': {
      'defaultValue': {
        'value': 'true',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether or not a 30px top margin is applied.'
    },
    'images': {
      'type': {
        'name': 'arrayOf',
        'value': {
          'name': 'shape',
          'value': {
            'original': {
              'name': 'string',
              'required': false
            },
            'thumbnail': {
              'name': 'string',
              'required': false
            },
            'originalAlt': {
              'name': 'string',
              'required': false
            },
            'thumbnailAlt': {
              'name': 'string',
              'required': false
            }
          }
        }
      },
      'required': true,
      'description': 'An array of objects representing images and their thumbnails.'
    }
  }
};